import { gql } from 'graphql-tag'

/* Why does this return product price: 0? */
const dailyManagementIncentiveProductsFragment = gql`
  fragment DailyManagementIncentiveProductsFragment on DailyManagement {
    salesIncentiveProducts {
      id
      name
      price
      category
    }
    salesIncentiveUnit
  }
`

const dailyManagementFragment = gql`
  fragment DailyManagementFragment on DailyManagement {
    id
    date
    shiftManagers {
      shift
      id
    }
    salesIncentiveTargets {
      shift
      target
      actual
    }
    thumbsUpTargets {
      shift
      target
      actual
    }
    nightTasks
    thumbsUpItems {
      id
      name
    }
    managementDailySales {
      type
      target
      actual
    }
    otherInfo
    chainIncentiveSalesTarget
  }
`

export const fetchDailyManagement = gql`
  query DailyManagement($stationId: ID!, $date: String!) {
    dailyManagement(stationId: $stationId, date: $date) {
      ...DailyManagementFragment
      ...DailyManagementIncentiveProductsFragment
    }
  }
  ${dailyManagementFragment}
  ${dailyManagementIncentiveProductsFragment}
`

export const createDailyManagement = gql`
  mutation CreateDailyManagement($stationId: ID!, $data: CreateDailyManagementInput!) {
    createDailyManagement(stationId: $stationId, data: $data) {
      ...DailyManagementFragment
      ...DailyManagementIncentiveProductsFragment
    }
  }
  ${dailyManagementFragment}
  ${dailyManagementIncentiveProductsFragment}
`

export const updateDailyManagement = gql`
  mutation UpdateDailyManagement($id: ID!, $data: UpdateDailyManagementInput!) {
    updateDailyManagement(dailyManagementId: $id, data: $data) {
      ...DailyManagementFragment
      ...DailyManagementIncentiveProductsFragment
    }
  }
  ${dailyManagementFragment}
  ${dailyManagementIncentiveProductsFragment}
`
